import { useState } from "react";
import { getEmailSuggestion } from "../services/email-suggestion";

export const useEmailSuggestion = () => {
  const [emailSuggestion, setEmailSuggestion] = useState(null);

  // Returns the suggestion so a submit handler can stop on a blocking typo
  const checkEmail = (email) => {
    const suggestion = getEmailSuggestion(email);
    setEmailSuggestion(suggestion);
    return suggestion;
  };

  const clearEmailSuggestion = () => setEmailSuggestion(null);

  return { emailSuggestion, checkEmail, clearEmailSuggestion };
};
